import OtherClickListener from './OtherClickListener';
import ScrollListener from './ScrollListener';
const initMartEvent = () => {
    // 外部クリック系
    OtherClickListener.init();
    // スクロールイベント
    ScrollListener.init();
};
export default initMartEvent;
